import React from 'react';
import { __ } from '@wordpress/i18n';

// store
import { useCommCenter } from '../../context';

// constants
import { ACTIVITY_CATEGORIES } from '../../constants';

const ActivityFilters = () => {
    const { activityFilter, setActivityFilter } = useCommCenter();

    const filters = [
        { id: 'all', label: __('Tutte', 'soundbetween') },
        { id: ACTIVITY_CATEGORIES.COMMENTS, label: __('Commenti', 'soundbetween') },
        { id: ACTIVITY_CATEGORIES.COMPLETED, label: __('Cue completate', 'soundbetween') },
        { id: ACTIVITY_CATEGORIES.EDITS, label: __('Modifiche', 'soundbetween') },
        { id: ACTIVITY_CATEGORIES.TEAM, label: __('Team', 'soundbetween') },
        { id: ACTIVITY_CATEGORIES.DEADLINES, label: __('Scadenze', 'soundbetween') },
    ];

    return (
        <div className="commChips" role="group" aria-label={__('Filtra le attività', 'soundbetween')}>
            {filters.map(filter => (
                <button
                    key={filter.id}
                    type="button"
                    className={`commChip ${activityFilter === filter.id ? 'is-active' : ''}`}
                    aria-pressed={activityFilter === filter.id}
                    onClick={() => setActivityFilter(filter.id)}>
                    {filter.label}
                </button>
            ))}
        </div>
    )
}

export default ActivityFilters;
